/**
 * DivButton — plain button with no browser chrome.
 * Migrated from styled-components to SCSS in 14.02.
 */
import { ButtonHTMLAttributes, forwardRef } from 'react';
import './DivButton.scss';

interface DivButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  color?: string;
  fontSize?: string;
}

/**
 * Default export — original minimal button (color + fontSize props).
 * Used directly in App.tsx for the logo clickable area.
 */
const DivButtonOG = forwardRef<HTMLButtonElement, DivButtonProps>(
  ({ className, ...props }, ref) => (
    <button
      ref={ref}
      type='button'
      className={['div-button', className].filter(Boolean).join(' ')}
      {...props}
    />
  ),
);
DivButtonOG.displayName = 'DivButtonOG';
export default DivButtonOG;

/**
 * Named export — full-reset button used as base for App header buttons.
 */
export const DivButton = forwardRef<HTMLButtonElement, DivButtonProps>(
  ({ className, ...props }, ref) => (
    <button
      ref={ref}
      type='button'
      className={['div-button-base', className].filter(Boolean).join(' ')}
      {...props}
    />
  ),
);
DivButton.displayName = 'DivButton';
